<template>
  <div>
    <!-- 手机端筛选弹窗 -->
    <el-drawer custom-class="my-drawer" title="筛选" :visible.sync="showMobileFilter" direction="btt" :before-close="handleClose" size="88%" :wrapperClosable="false">
      <div class="main-content">
        <!-- 报销类型 -->
        <div>
          <div class="title">报销类型</div>
          <div class="item-select" :class="{ 'item-select-active': allType }" @click="handleSelectedAllType">全部</div>
          <div v-for="data in invoiceTypeOptions" class="item-select" :class="{ 'item-select-active': paramForm.invoiceTypeList.includes(data.id) }" :key="data.id"
            @click="handleSelectedType(data.id)">
            {{ data.name }}
          </div>
        </div>
        <!-- 报销人 -->
        <div>
          <div class="title">报销人</div>
          <div v-for="data in salePersonOption" class="item-select sale" :class="{ 'item-select-active': paramForm.userId == data.id }" :key="data.id"
            @click="paramForm.userId = data.id">
            {{ data.name }}
          </div>
        </div>
        <!-- 发生日期 -->
        <div>
          <div class="title">发生日期</div>
          <div class="filter-date-box">
            <el-date-picker style="width: 100%" v-model="paramForm.invoiceDateStart" type="date" placeholder="开始时间" value-format="yyyy-MM-dd">
            </el-date-picker>
            <span>-</span>
            <el-date-picker style="width: 100%" v-model="paramForm.invoiceDateEnd" type="date" placeholder="结束时间" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </div>
        <!-- 排序 -->
        <div>
          <div class="title">排序</div>
          <div class="item-select" :class="{ 'item-select-active': paramForm.sortType == 0 }" @click="paramForm.sortType = 0">发生日期最早</div>
          <div class="item-select" :class="{ 'item-select-active': paramForm.sortType == 1 }" @click="paramForm.sortType = 1">发生日期最晚</div>
        </div>
        <!-- 关联拜访 -->
        <div>
          <div class="title">关联拜访</div>
          <div class="item-select" :class="{ 'item-select-active': paramForm.hasVisit === '' }" @click="paramForm.hasVisit = ''">全部</div>
          <div class="item-select" :class="{ 'item-select-active': paramForm.hasVisit == 1 }" @click="paramForm.hasVisit = 1">已关联</div>
          <div class="item-select" :class="{ 'item-select-active': paramForm.hasVisit == 0 }" @click="paramForm.hasVisit = 0">未关联</div>
        </div>
      </div>
      <div class="footer-btn">
        <div class="button cancel" @click="handleClose">取消</div>
        <div class="button confirm" @click="confirm">确定</div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    showMobileFilter: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      allType: true,
      paramForm: {
        invoiceTypeList: [],
      },
      // 报销类型：1-住宿费 2-交通费 3-餐饮 4-业务
      invoiceTypeOptions: [
        { id: 1, name: "住宿费" },
        { id: 2, name: "交通费" },
        { id: 4, name: "客户维护费" },
        { id: 6, name: "服务费" },
        { id: 5, name: "其他" },
      ],
    };
  },
  watch: {
    showMobileFilter(val) {
      if (!val) {
        return;
      }
      this.$nextTick(() => {
        this.paramForm = JSON.parse(JSON.stringify(this.form));
        this.allType = this.paramForm.invoiceTypeList.length > 0 ? false : true;
      });
    },
  },
  computed: {
    ...mapState(["salePersonOption"]),
  },
  methods: {
    confirm() {
      let param = { ...this.paramForm };
      this.$emit("confirm", param);
      this.handleClose();
    },
    handleClose() {
      this.paramForm = {
        invoiceTypeList: [],
        hasVisit: '',
      };
      this.allType = true;
      this.$emit("update:showMobileFilter", false);
    },
    // 报销类型 正选反选
    handleSelectedType(val) {
      let index = this.paramForm.invoiceTypeList.indexOf(val);
      if (index == -1) {
        this.paramForm.invoiceTypeList.push(val);
      } else {
        this.paramForm.invoiceTypeList.splice(index, 1);
      }
      this.allType = this.paramForm.invoiceTypeList.length > 0 ? false : true;
    },
    handleSelectedAllType() {
      this.allType = true;
      this.paramForm.invoiceTypeList = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  padding: 0 1.5rem 7rem;
  .title {
    font-size: 1.14rem;
    font-weight: 550;
    margin: 1rem 0;
  }
  .filter-date-box {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .item-select {
    width: calc((100% / 2) - 0.5rem);
    display: inline-block;
    padding: 0.5rem 0.8rem;
    border-radius: 8px;
    color: #333333;
    background-color: rgba(0, 0, 0, 0.05);
    margin: 0 0.5rem 0.5rem 0;
    text-align: center;
  }
  .item-select-active {
    border: 1px solid $primary-btn-color;
    color: $primary-btn-color;
    background-color: rgba(4, 65, 144, 0.1);
  }
  .sale {
    width: calc((100% / 3) - 0.5rem);
  }
}
.footer-btn {
  padding: 10px 20px;
  background-color: #fff;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  @include SAFE-BOTTOM-IOS;
  display: flex;
  .button {
    border-radius: 12px;
    border: none;
    padding: 0.86rem 0;
    font-size: 1.14rem;
    text-align: center;
  }
  .cancel {
    width: 25%;
    color: $primary-font-color;
    margin-right: 1rem;
    background-color: rgba(0, 0, 0, 0.08);
  }
  .confirm {
    flex: 1;
    background-color: $primary-btn-color;
    color: #fff;
  }
}
</style>
<style lang="scss">
.my-drawer {
  border-radius: 12px 12px 0 0;
  .el-drawer__header {
    text-align: center;
    color: $primary-font-color;
    font-weight: 550;
    font-size: 1.14rem;
    margin-bottom: 1rem;
    padding-left: 40px;
  }
}
</style>
